import api from "../services/api";


// Create Agent Training
export const createAgentTraining = async (payload) => {
  try {
    const response = await api.post(
      "/agent-training-management/create",
      payload
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        error:
          response.data?.message ||
          "Unexpected response from server",
      };
    }

  } catch (error) {

    console.error(
      "Error creating Agent Training:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to create Agent Training",
    };
  }
};


// Fetch Agent Training Materials
export const fetchAgentTraining = async (
  page = 1,
  size = 10
) => {
  try {

    const response = await api.get(
      "/agent-training-management/list",
      {
        params: {
          page,
          size,
        },
      }
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        error:
          response.data?.message ||
          "Unexpected response from server",
      };
    }

  } catch (error) {

    console.error(
      "Error fetching Agent Training:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch Agent Training",
    };
  }
};


// Update Agent Training
export const updateAgentTraining = async (
  trainingId,
  payload
) => {
  try {

    const response = await api.put(
      `/agent-training-management/update/${trainingId}`,
      payload
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        error:
          response.data?.message ||
          "Unexpected response from server",
      };
    }

  } catch (error) {

    console.error(
      "Error updating Agent Training:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to update Agent Training",
    };
  }
};


// Delete Agent Training
export const deleteAgentTraining = async (
  trainingId
) => {
  try {

    const response = await api.delete(
      `/agent-training-management/delete/${trainingId}`
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
        message:
          response.data.message ||
          "Training material deleted successfully.",
      };
    } else {
      return {
        success: false,
        error:
          response.data?.message ||
          "Unexpected response from server",
      };
    }

  } catch (error) {

    console.error(
      "Error deleting Agent Training:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to delete Agent Training",
    };
  }
};